export const DeviceModeList = ['mobile', 'desktop'] as const;
export type DeviceMode = (typeof DeviceModeList)[number];
